/**
 * La marca de Clean Blue: el círculo con la cruz sanitaria.
 *
 * Existe porque había cuatro versiones distintas del logo —un PNG con filtro
 * en la barra lateral, dos SVG diferentes en el portal y en el ingreso, y el
 * portal del empleado sin marca— y cada superficie se veía como otra empresa.
 * Acá vive el único dibujo.
 *
 * El PNG no servía: es un lienzo cuadrado con ~30% de margen transparente
 * arriba y abajo, así que a 30px de alto el wordmark quedaba en 2,45px
 * —ilegible— y descentrado. Y el `filter: brightness(0) invert(1)` que lo
 * blanqueaba sobre la barra borraba la cruz: la cruz es blanca **opaca**, no
 * un recorte, así que el filtro la pintaba del mismo blanco que el círculo y
 * quedaba un disco liso.
 */
export function Brandmark({ size = 30 }: {
  /** Lado del cuadrado, en px. */
  size?: number;
}) {
  /* Los colores de la marca **no cambian con el fondo**: círculo celeste
     (`--brand`, #4890ba) y cruz blanca, en las cuatro superficies.
     Hubo un intento de invertirlos sobre la barra oscura por miedo a que la
     cruz se perdiera; era infundado —el celeste contrasta de sobra contra el
     navy— y a cambio mostraba una marca que no es la de la empresa. */
  const disc = 'var(--brand)';
  const cross = '#fff';

  return (
    // `aria-hidden`: en las cuatro superficies el nombre «Clean Blue» ya está
    // escrito al lado, así que anunciarlo otra vez sería repetirlo.
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      style={{ display: 'block', flex: 'none' }}
    >
      <circle cx="32" cy="32" r="30" fill={disc} />
      {/* La cruz es DOS rectángulos cruzados, no un polígono de doce esquinas:
          se lee de un vistazo y las esquinas exteriores redondeadas salen
          solas con `rx`. Las proporciones están medidas sobre el logo
          original — brazo 0,77 del diámetro y grosor 0,29 — porque la cruz
          real casi toca el borde del círculo; una más chica no es la marca. */}
      <rect x="23.3" y="9" width="17.4" height="46" rx="2" fill={cross} />
      <rect x="9" y="23.3" width="46" height="17.4" rx="2" fill={cross} />
    </svg>
  );
}
